import { DataSecurityAppName } from '@ui/applications';
import { getAppColor } from '@security/@arch/lib';
import { isEqual } from 'lodash';
import { useApplicationReferences } from '@hooks/references';
import { usePrevious } from '@hooks/usePrevious';

import { useEffect, useState } from 'react';

type DataSecurityAppColors = Partial<Record<number, string>>;

export function useDataSecurityAppColors(appIds?: number[]): DataSecurityAppColors {
	const [ applicationColors, setApplicationColors ] = useState<DataSecurityAppColors>({});
	const apps = useApplicationReferences();
	const previousAppIds = usePrevious(appIds);

	useEffect(() => {
		if (appIds && !isEqual(appIds, previousAppIds)) {
			appIds.forEach((id) => {
				const { name } = apps[ id ] ?? {};
				getAppColor(name as DataSecurityAppName, (color: string) => {
					setApplicationColors((colors) => ({
						...colors,
						[ id ]: color
					}));
				});
			});
		}
	}, [ appIds, applicationColors, apps, previousAppIds ]);

	return applicationColors;
}
